import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { getPayload, loadingStatus } from "../../actions"
import Title from "../general/title"
import ReactTable from "react-table"
import moment from "moment"
import { withRouter } from "react-router-dom"
import _ from "lodash"
import Modal from "react-responsive-modal"
import BustoutModal from "./modals/bustout"
import ContractModal from "./modals/contract"
import TransferModal from "./modals/transfer"
import ClosingModal from "./modals/closing"
import StartModal from "./modals/start"
import LotReservationModal from "./modals/lotReservation"
import Fees from "./modals/fees"
import CompleteModal from "./modals/complete"
import EstimatedModal from "./modals/estimated"
import MoveInDate from "./modals/moveInDate"
const ArcModal = React.lazy(() => import("./modals/arcSubmitLot"))
import FinalModal from "./modals/arcFinalSubmit"
import OpenHouse from "./modals/openHouse"
import ArcViewApprovedLot from "./modals/arcViewApprovedLot"
import BuyerModal from "./modals/buyer"
import { toast } from "react-toastify"
import { storePref, checkPref, removePref } from "helpers/pref"
import settings from "settings"
import classnames from "classnames"
import currentUser from "helpers/currentUser"
import helpers from "helpers/helpers"
import { storeFilterPref, checkFilterPref } from "helpers/filterPref"
import WebsiteInfoBuilders from "./modals/websiteInfoBuilders"
import EditHomeInfo from "./modals/editHomeInfo"
import classNames from "classnames"
import submitDataAsync from "helpers/asyncSubmitData"

class LotInventory extends Component {
	constructor(props) {
		super(props)
		let pref = checkPref("portal__lotInventory__filtered")
		let addl = []
		if (_.get(settings, `enabled.extendedLotInventoryColumns`) && currentUser().group !== 14) {
			addl = [
				{
					Header: "Estimated Closing Date",
					accessor: "estimated_closing",
					filterable: false,
					Cell: (props) => (props && props.value ? moment.unix(props.value).format("MM/DD/YY") : ""),
					maxWidth: 125,
				},
				{
					Header: "Floorplan",
					accessor: "floorplan",
					filterMethod: (f, r) => helpers.tableText(f, r, "floorplan"),
				},
				{
					Header: "Square Feet",
					accessor: "sqft",
					filterMethod: (f, r) => helpers.tableText(f, r, "sqft"),
				},
				{
					Header: "Sales Price",
					accessor: "price",
					filterMethod: (f, r) => helpers.tableText(f, r, "price"),
				},
				{
					Header: "Buyer Last Name",
					accessor: "buyer_last",
					filterMethod: (f, r) => helpers.tableText(f, r, "buyer_last"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Neighborhood",
					accessor: "neighborhood",
					filterMethod: (f, r) => helpers.tableText(f, r, "neighborhood"),
				},
				{
					Header: "Realtor",
					accessor: "realtor",
					filterMethod: (f, r) => helpers.tableText(f, r, "realtor"),
				},
				{
					Header: "Construction Status",
					accessor: "construction_status",
					filterMethod: (f, r) => helpers.tableText(f, r, "construction_status"),
				},
			]
		}
		let actions = {
			Header: "Actions",
			accessor: "actions",
			className: "actions",
			filterable: false,
			minWidth: 250,
		}
		this.user = currentUser()
		this.state = {
			user: currentUser(),
			loading: true,
			valid: false,
			id: 0,
			transferModal: false,
			startModal: false,
			completeModal: false,
			closingModal: false,
			estimatedModal: false,
			lotReservationModal: false,
			buyerModal: false,
			finalModal: false,
			moveInDateModal: false,
			contractModal: false,
			websiteInfoModal: false,
			editHomeInfoModal: false,
			bustoutModal: false,
			historyModal: false,
			openHouseModal: false,
			arcModal: false,
			viewApproved: false,
			data: {},
			filtered: pref ? pref : [],
			toggleShow: false,
			rows: [],
			columns: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Section",
					accessor: "section",
					width: this.getColumnWidth(this.rows, "section", "Section"),
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Block",
					accessor: "block",
					filterMethod: (f, r) => helpers.tableText(f, r, "block"),
					width: this.getColumnWidth(this.rows, "block", "Block"),
				},
				{
					Header: "Lot",
					accessor: "lot",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
					width: this.getColumnWidth(this.rows, "lot", "Lot"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Buyer Last",
					accessor: "buyer_last",
					filterMethod: (f, r) => helpers.tableText(f, r, "buyer_last"),
				},
				...(this.user.group === 14
					? [
							{
								Header: "Approval Status",
								accessor: "arcStatus",
								filterMethod: (f, r) => helpers.tableText(f, r, "arcStatus"),
							},
					  ]
					: []),
				{
					Header: "Contract Date",
					accessor: "sale_date",
					filterable: false,
					Cell: (props) => (props && props.value ? moment.unix(props.value).format("MM/DD/YY") : ""),
					maxWidth: 125,
				},
				{
					Header: "Closing Date",
					accessor: "closing_date",
					filterable: false,
					Cell: (props) => (props && props.value ? moment.unix(props.value).format("MM/DD/YY") : ""),
					maxWidth: 125,
				},
				...addl,
			],
		}
		if (addl.length > 0) {
			this.state.columns.unshift(actions)
		} else {
			this.state.columns.push(actions)
		}
	}

	componentDidMount() {
		let rows
		if (this.state.user.group == 14) {
			rows = this.buildARCTable()
		} else {
			rows = this.buildTable()
		}
		this.setState({ rows })
		this.init()
	}

	init = () => {
		let columns = _.cloneDeep(this.state.columns)
		let pref = checkPref("portal__lotInventoryFilters")
		_.forEach(columns, (v) => {
			if (!v.hasOwnProperty("display")) {
				v.display = true
			}
		})
		if (pref) {
			_.forEach(pref, (v, k) => {
				let f = _.findIndex(columns, { accessor: k })

				if (!columns[f]) {
					return
				}
				columns[f].display = v
			})
		}
		let filtered
		let filteredCheck = checkFilterPref("portal__lotInventoryFilters")
		if (filteredCheck) filtered = filteredCheck
		this.setState({ columns, filtered })
	}

	storePref = (type, columns) => {
		let storage = {}
		for (let v of columns) {
			storage[v.accessor] = v.display
		}
		storePref("portal__lotInventoryFilters", storage)
	}

	getColumnWidth = (data, accessor, headerText) => {
		if (!data) return
		if (typeof accessor === "string" || accessor instanceof String) {
			accessor = (d) => d[accessor]
		}
		const maxWidth = 600
		const magicSpacing = 10
		const cellLength = Math.max(...data.map((row) => (`${accessor(row)}` || "").length), headerText.length)
		return Math.min(maxWidth, cellLength * magicSpacing)
	}

	buttonClick = (modal, data) => {
		this.setState({
			[modal]: true,
			data,
		})
	}

	buildTable = () => {
		let twoMonths = moment().subtract(1, "week").unix()
		return _.map(this.props.payload?.salespersonPayload?.lots?.current, (r) => {
			let property = _.find(this.props.payload.public.properties, { id: r.property })
			let sec = _.find(this.props.payload.public.sections, { id: r.section_id })
			let builder = _.find(this.props.payload.public.builders, { id: r.builder })
			let lot_type = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
			let neighborhood = _.find(this.props.payload.public.neighborhoods, { id: r.neighborhood })
			let sale = _.find(this.props.payload.salespersonPayload.lots.allSales, { sale_id: r.sale_id })
			let section = sec ? sec.name : ""
			let start,
				saleActions,
				contractActions,
				profile,
				complete,
				arc,
				estimatedClosing,
				openHouse,
				lotReservations,
				websiteInfo,
				move_in_date,
				final,
				editHomeInfo
			let construction_status
			let needPaperwork = false
			let requirePaperworkBeforeClosing = settings.requirePaperworkBeforeClosing
			// Compile global buttons first
			//if ((r.lot_status == 'Contract' && !r.estimated_closing) || (!r.closing_date && r.estimated_closing && r.estimated_closing < twoMonths)) {
			let viewPlans
			let text = "Submit"
			if (r.arc_data) {
				text = "Edit"
			}
			if (r.sale_id && property.no_paperwork !== 1) {
				let awaitingOrRejected = false
				_.forEach(r.documents, (v) => {
					if (v.status !== "accepted") {
						needPaperwork = true
					}
					if (["awaiting", "rejected"].includes(v.status)) {
						awaitingOrRejected = true
					}
				})
				if (!r.documents) {
					needPaperwork = true
				}
				if (needPaperwork) {
					let att
					if (requirePaperworkBeforeClosing && awaitingOrRejected) att = "btn--attention"
					profile = (
						<button className={`btn ${att}`} onClick={() => this.buttonClick("buyerModal", r)}>
							Buyer Paperwork
						</button>
					)
				}
			}
			if (r.arc_approved && _.has(r.arc_data, `approval_date`)) {
				// This is split out because thsi means pipsy was in control when this was approved.  If it's not, like during import of a new developer, then we probably won't have this info.
				viewPlans = (
					<button className="btn darkGreen" onClick={() => this.buttonClick("viewApproved", r)}>
						View Approved Plans
					</button>
				)
				text = "Resubmit"
			}
			if (r.lot_status == "Contract") {
				let att
				if (r.estimated_closing < twoMonths) att = "btn--attention"
				estimatedClosing = (
					<button className={`btn ${att}`} onClick={() => this.buttonClick("estimatedModal", r)}>
						Edit Estimated Closing
					</button>
				)
			}
			if (!r.start_date && !settings?.disableBuilderConstructionStatus) {
				start = (
					<button
						className={classnames("btn", { "btn--attention": r.missing_start })}
						onClick={() => this.buttonClick("startModal", r)}>
						Add Start
					</button>
				)
				construction_status = "Vacant"
			}
			if (r.start_date && !r.complete_date && !r.sale_id) {
				move_in_date = (
					<button className={classnames("btn", {})} onClick={() => this.buttonClick("moveInDateModal", r)}>
						Edit Move In Date
					</button>
				)
			}
			if (r.start_date && !r.complete_date && !settings?.disableBuilderConstructionStatus) {
				complete = (
					<button
						className={classnames("btn", { "btn--attention": r.missing_complete })}
						onClick={() => this.buttonClick("completeModal", r)}>
						Add Complete
					</button>
				)
				construction_status = "Start"
			}
			if (r.complete_date) {
				construction_status = "Spec"
			}
			if (r.sale_date && !r.closing_date && !r.bustout_date) {
				let closing
				if (r.sale_date && !r.closing_date) {
					closing = (
						<button className="btn" onClick={() => this.buttonClick("closingModal", r)}>
							Add Closing
						</button>
					)
					if (requirePaperworkBeforeClosing && needPaperwork) closing = null
				}
				contractActions = (
					<span>
						<button className="btn" onClick={() => this.buttonClick("bustoutModal", r)}>
							Cancel Contract
						</button>
						<button className="btn" onClick={() => this.buttonClick("transferModal", r)}>
							Transfer Lot
						</button>
						{closing}
					</span>
				)
			}
			if (!r.sale_date && !r.closing_date) {
				contractActions = (
					<span>
						<button className="btn" onClick={() => this.buttonClick("contractModal", r)}>
							Add Contract
						</button>
					</span>
				)
			}
			if (settings.arc && !r.closing_date) {
				let text = "Submit"
				if (r.arc_data) {
					text = "Edit"
				}

				arc = (
					<button className="btn" onClick={() => this.buttonClick("arcModal", r)}>
						{text} Architectural Plan
					</button>
				)
			}
			if (_.get(settings, `enabled.openHouses`) && r.start_date && !r.sale_id) {
				// If arc is disabled and this lot isn't in a feed, then skip open house
				if (!settings.arc && !r.in_feed && !r.in_feed_manual) {
				} else {
					// Check that this property is using the public app - what if they aren't using our app?
					let property = _.find(this.props.payload.public.properties, { id: r.property })
					if (property.public_app) {
						let text = ""
						if (!r.open_house) text = "Add"
						else text = "Modify"
						openHouse = (
							<button className="btn" onClick={() => this.buttonClick("openHouseModal", r)}>
								{text} Open House
							</button>
						)
					}
				}
			}
			if (
				_.get(settings, `enabled.lotReservations`) &&
				settings.enabled.lotReservations.includes(r.property) &&
				!r.closing_date &&
				!r.sale_date &&
				!r.start_date &&
				!r.complete_date
			) {
				// Check that this property is using the public app - what if they aren't using our app?
				let text = ""
				if (!r.reserve_start_date) text = "Add"
				else text = "Modify"
				lotReservations = (
					<button className="btn" onClick={() => this.buttonClick("lotReservationModal", r)}>
						{text} Lot Reservation
					</button>
				)
			}
			if (_.get(settings, `enabled.builderWebsiteInfo`) && r.start_date && !r.closing_date) {
				// Check that this property is using the public app - what if they aren't using our app?
				websiteInfo = (
					<button className="btn" onClick={() => this.buttonClick("websiteInfoModal", r)}>
						Website Info
					</button>
				)
			}
			let homeInfo = _.get(settings, `enabled.builderEditHomeInfo`)
			if (homeInfo?.enabled) {
				if ((homeInfo.requireStartDate && r.start_date) || !homeInfo.requireStartDate) {
					editHomeInfo = (
						<button className="btn" onClick={() => this.buttonClick("editHomeInfoModal", r)}>
							Home Info
						</button>
					)
				}
			}
			// Final review logic
			if (!settings?.disabled?.finalReview) {
				if (settings.arc && (r?.arc_data?.fr === null || r?.arc_data?.fr === false) && r.complete_date) {
					// rejected fr
					final = (
						<button
							className={classNames("btn", {
								"btn--attention": r?.arc_data?.fr === false,
							})}
							onClick={() => this.buttonClick("finalModal", r)}>
							Resubmit Final Review
						</button>
					)
				} else if (settings.arc && r?.arc_data?.fr === undefined && r.complete_date) {
					// no fr
					final = (
						<button className="btn" onClick={() => this.buttonClick("finalModal", r)}>
							Submit Final Review
						</button>
					)
				}
			}
			// If no conditional approval, do not allow start
			if (settings.arcRequireApprovalBeforeStart && !r?.arc_data?.conditional_approval) {
				start = null
			}
			// Scenarios where ARC is on, but they don't submit ARC here, like signorelli who uses mccauley and APR
			if (settings?.disabled?.submitArcButton) {
				arc = null
			}
			let actions = (
				<div>
					{start}
					{complete}
					{saleActions}
					{contractActions}
					{profile}
					{estimatedClosing}
					{arc}
					{viewPlans}
					{openHouse}
					{lotReservations}
					{websiteInfo}
					{editHomeInfo}
					{move_in_date}
					{final}
				</div>
			)
			//? These are overrides for almost everything above for specific cases, like SRR only wanting marketing + arc on salespeople.  Can add to as necessary.
			if (settings.builderPortalOnlyMarketing && !this.state?.user?.viewAs) {
				actions = (
					<div>
						{websiteInfo}
						{editHomeInfo}
					</div>
				)
			} else if (settings.builderPortalMarketingAndARC && !this.state?.user?.viewAs) {
				actions = (
					<div>
						{websiteInfo}
						{arc}
						{viewPlans}
						{editHomeInfo}
					</div>
				)
			}
			let community = _.find(this.props.payload.public.properties, { id: r.property })
			return {
				section: section,
				block: r.block,
				lot: r.lot,
				builder: builder.name,
				address: r.address,
				sqft: r.sqft,
				construction_status,
				lot_type: lot_type ? lot_type.name : "",
				neighborhood: neighborhood ? neighborhood.name : "",
				realtor: sale ? sale.realtor_name : "",
				addressText: r.address,
				floorplan: r.floorplan_label,
				buyer_last: r.primary_last,
				//buyer_first: r.primary_first,
				sale_date: r.sale_date,
				price: r.price,
				closing_date: r.closing_date,
				estimated_closing: r.estimated_closing,
				actions: actions,
				community: community && community.name,
				documents: r.documents,
				property: r.property,
			}
		})
	}

	buildARCTable = () => {
		return _.map(this.props.payload.arcPayload.lots, (r) => {
			let sec = _.find(this.props.payload.public.sections, { id: r.section_id })
			let builder = _.find(this.props.payload.public.builders, { id: r.builder })
			let floorplan = _.find(this.props.payload.public.floorplans, { id: r.floorplan })
			let lot_type = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
			let neighborhood = _.find(this.props.payload.public.neighborhoods, { id: r.neighborhood })
			let sale = _.find(this.props.payload.salespersonPayload.lots.allSales, { sale_id: r.sale_id })
			let section = sec ? sec.name : ""
			let construction_status, editHomeInfo, websiteInfo, addClosing, fees
			let arcStatus = ""
			let text = "Submit"
			if (r.arc_data) {
				text = "Edit"
			}
			if (r.arc_approved) arcStatus = "Approved"
			else if (r?.arc_data?.current_status === "conditional") arcStatus = "Conditional"
			else if (r?.arc_data?.current_status === "rejected") arcStatus = "Rejected"
			let view, viewResponseFile, start, complete, final
			if (r.arc_approved && _.has(r.arc_data, `approval_date`)) {
				// This is split out because thsi means pipsy was in control when this was approved.  If it's not, like during import of a new developer, then we probably won't have this info.
				view = (
					<button className="btn darkGreen" onClick={() => this.buttonClick("viewApproved", r)}>
						View Approved Plans
					</button>
				)
				text = "Resubmit"
			}
			if (settings.arc && r.arc_data) {
				let files = {
					approved: _.get(r.arc_data, `approval_file`),
					rejected: _.get(r.arc_data, `rejection_file`),
					conditional: _.get(r.arc_data, `conditional_file`),
				}
				if (r.arc_approved && files.approved && _.get(r.arc_data, `current_status`) == "approved") {
					viewResponseFile = (
						<a
							className="btn"
							target="_blank"
							onClick={async () => {
								this.generateResponseFile(r)
							}}>
							Approved Response File
						</a>
					)
				} else if (files.conditional && _.get(r.arc_data, `current_status`) == "conditional") {
					viewResponseFile = (
						<a
							className="btn"
							target="_blank"
							onClick={async () => {
								this.generateResponseFile(r)
							}}>
							Conditional Response File
						</a>
					)
				} else if (files.rejected && _.get(r.arc_data, `current_status`) == "rejected") {
					viewResponseFile = (
						<a className="btn" target="_blank" href={`${settings.s3}${files.rejected}`}>
							Rejected Response File
						</a>
					)
				}
			}
			if (r.takedown_date && !r.start_date && !settings?.disableBuilderConstructionStatus) {
				start = (
					<button
						className={classnames("btn", { "btn--attention": r.missing_start })}
						onClick={() => this.buttonClick("startModal", r)}>
						Add Start
					</button>
				)
				construction_status = "Vacant"
			}
			if (r.takedown_date && r.start_date && !r.complete_date && !settings?.disableBuilderConstructionStatus) {
				complete = (
					<button
						className={classnames("btn", { "btn--attention": r.missing_complete })}
						onClick={() => this.buttonClick("completeModal", r)}>
						Add Complete
					</button>
				)
				construction_status = "Start"
			}
			if (!r.start_date) {
				construction_status = "Vacant"
			}
			if (r.start_date && !r.complete_date) {
				construction_status = "Start"
			}
			if (r.complete_date) {
				construction_status = "Spec"
			}
			if (
				_.get(settings, `enabled.arcClosingAbility`) &&
				settings.enabled.arcClosingAbility.includes(r.property) &&
				r.sale_date &&
				!r.closing_date &&
				!r.bustout_date
			) {
				addClosing = (
					<button className="btn" onClick={() => this.buttonClick("closingModal", r)}>
						Add Closing
					</button>
				)
			}
			// Edit home info logic
			let homeInfo = _.get(settings, `enabled.builderEditHomeInfo`)
			if (homeInfo?.enabled) {
				if ((homeInfo.requireStartDate && r.start_date) || !homeInfo.requireStartDate) {
					editHomeInfo = (
						<button className="btn" onClick={() => this.buttonClick("editHomeInfoModal", r)}>
							Home Info
						</button>
					)
				}
			}
			if (_.get(settings, `enabled.builderWebsiteInfo`) && r.start_date) {
				// Check that this property is using the public app - what if they aren't using our app?
				websiteInfo = (
					<button className="btn" onClick={() => this.buttonClick("websiteInfoModal", r)}>
						Website Info
					</button>
				)
			}

			// Final review logic
			if (!settings?.disabled?.finalReview) {
				if (
					(r?.arc_data?.fr === null || r?.arc_data?.fr === false) &&
					r.complete_date &&
					r?.arc_data?.fr_review_date
				) {
					// rejected fr
					final = (
						<button
							className={classNames("btn", {
								"btn--attention": r?.arc_data?.fr === false,
							})}
							onClick={() => this.buttonClick("finalModal", r)}>
							Resubmit Final Review
						</button>
					)
				} else if (r?.arc_data?.fr === undefined && r.complete_date) {
					// no fr
					final = (
						<button className="btn" onClick={() => this.buttonClick("finalModal", r)}>
							Submit Final Review
						</button>
					)
				}
			}
			// require at least conditional approval before start
			if (settings.arcRequireApprovalBeforeStart && !r?.arc_data?.conditional_approval) {
				start = null
			}
			if (settings.arc && settings?.enabled?.builderFeeEntry && !r.arc_approved && r.arc_data) {
				fees = (
					<button className="btn" onClick={() => this.buttonClick("feesModal", r)}>
						Fees
					</button>
				)
			}
			let actions = (
				<div>
					<button className="btn" onClick={() => this.buttonClick("arcModal", r)}>
						{text} Architectural Plan
					</button>
					{final}
					{start}
					{complete}
					{addClosing}
					{fees}
					{view}
					{viewResponseFile}
					{editHomeInfo}
					{websiteInfo}
				</div>
			)
			//if(r.arc_approved) actions = 'Approved'

			let community = _.find(this.props.payload.public.properties, { id: r.property })
			return {
				section: section,
				block: r.block,
				lot: r.lot,
				builder: builder.name,
				floorplan: floorplan ? floorplan.name : "",
				lot_type: lot_type ? lot_type.name : "",
				neighborhood: neighborhood ? neighborhood.name : "",
				sqft: r.sqft,
				construction_status,
				realtor: sale ? sale.realtor_name : "",
				address: r.address,
				addressText: r.address,
				buyer_last: r.primary_last,
				sale_date: r.sale_date,
				price: r.price,
				closing_date: r.closing_date,
				actions: actions,
				community: community && community.name,
				property: r.property,
				arcStatus,
			}
		})
	}

	notify = (d, name) => {
		//return
		if (d.status == 200) {
			toast.success(d.message)
			this.setState({
				[name]: false,
			})
			this.props.getPayload()
		} else {
			toast.error(d.message)
		}
	}

	toggleShow = () => {
		this.setState({ toggleShow: !this.state.toggleShow })
	}

	checkboxChange = (e, i) => {
		let columns = _.cloneDeep(this.state.columns)
		let index
		if (typeof i == "number") {
			index = i
		} else {
			index = _.findIndex(columns, { name: e.target.Header })
		}
		columns[index].display = !columns[index].display
		this.storePref("portal__lotInventoryFilters", columns)
		this.setState({ columns })
	}

	renderFilters = () => {
		let checkboxes = []
		_.forEach(this.state.columns, (v) => {
			if (v.disableFilter) return
			let index = _.findIndex(this.state.columns, { accessor: v.accessor })
			checkboxes.push(
				<li
					className="filterCheckboxes__item"
					key={v.Header}
					data-value={v.Header}
					onClick={() => this.checkboxChange(null, index)}>
					<input
						type="checkbox"
						name={v.Header}
						value={v.Header}
						checked={this.state.columns[index].display}
						onChange={() => {
							this.checkboxChange(null, index)
						}}
					/>
					{v.name ? v.name : v.Header}
				</li>
			)
		})

		return checkboxes
	}

	checkAll = (value) => {
		let state = _.cloneDeep(this.state.columns)
		_.forEach(state, (v, k) => {
			state[k].display = value
		})
		this.storePref(this.props.name, state)
		this.setState({ columns: state })
	}

	displayColumns = () => {
		let ret = _.filter(this.state.columns, { display: true })
		return ret
	}

	renderInventory = () => {
		if (this.state.user.group == 15) return
		return (
			<div>
				<ReactTable
					filterable
					loadingText=""
					filtered={this.state.filtered}
					onFilteredChange={(filtered) => {
						this.setState({ filtered: filtered })
						storePref(`portal__lotInventory__filtered`, filtered)
					}}
					data={this.state.rows}
					columns={this.displayColumns()}
					defaultPageSize={30}
					className="small"
					getTrProps={this.getTrProps}
					defaultSorted={[
						{
							id: "sale_date",
							desc: true,
						},
					]}>
					{(state, makeTable) => {
						let totalRecords = ""
						const { sortedData } = state
						if (sortedData && sortedData.length > 0) {
							totalRecords = sortedData.length
						} else totalRecords = 0
						return (
							<>
								<p className="rowCount">
									Number of Lots: {totalRecords.toLocaleString()} | Page: {state.page + 1} | Viewing
									Records : {state.startRow + 1} - {state.endRow}
								</p>
								{!settings.disablePaperwork && (
									<ul className="legend__list">
										<li>
											<span className="statusColor--awaiting" /> Awaiting Paperwork
										</li>
										<li>
											<span className="statusColor--pending" /> Pending Approval
										</li>
										<li>
											<span className="statusColor--rejected" /> Rejection
										</li>
										<li>
											<span className="statusColor--approved" /> Approved Paperwork
										</li>
									</ul>
								)}
								<div className="pointer clearFilters clearFilters--duo">
									<div>
										<div className="titleFilter">
											<p className="filterCheck">
												<span onClick={() => this.checkAll(true)}>Check All</span>
												<span onClick={() => this.checkAll(false)}>Uncheck All</span>
											</p>
										</div>
										<div className="filterCheckboxes__cont">
											<div
												className="filterCheckboxes__toggle"
												onClick={() => this.toggleShow()}
												data-html2canvas-ignore="true">
												{this.state.toggleShow ? "Hide" : "Show"} Filters
											</div>
											{this.state.toggleShow && (
												<ul className="filterCheckboxes" data-html2canvas-ignore="true">
													{this.renderFilters()}
												</ul>
											)}
										</div>
									</div>
								</div>
								<div className="pointer clearFilters" style={{ textAlign: "right", paddingBottom: 20 }}>
									<a
										onClick={() => {
											this.setState({ filtered: [] })
											removePref("portal__lotInventory__filtered")
										}}>
										<i className="fas fa-times-circle"></i> Clear Text
									</a>
								</div>
								{makeTable()}
							</>
						)
					}}
				</ReactTable>
			</div>
		)
	}

	documentsList = () => {
		if (!this.state.data.lot?.arc_history) return null
		let ret = []
		_.forEach(this.state.data.lot.arc_history, (v, k) => {
			let cond = v?.data?.conditional_file
			let plan = v?.data?.plan_file
			let approval = v?.data?.approval_file
			let buttons = []
			if (cond) {
				buttons.push(
					<a className="btn tiny !bg-orange-600 mr-2" href={`${settings.s3}${cond}`} target="_blank">
						Conditional Approval
					</a>
				)
			}
			if (plan) {
				buttons.push(
					<a className="btn tiny mr-2" href={`${settings.s3}${plan}`} target="_blank">
						Plan File
					</a>
				)
			}
			if (approval) {
				buttons.push(
					<a className="btn tiny !bg-green-700 mr-2" href={`${settings.s3}${approval}`} target="_blank">
						Full Approval
					</a>
				)
			}
			if (buttons.length) {
				ret.push(
					<tr key={k}>
						<td className="text-sm">{moment.unix(v.addedDate).format("MM/DD/YY")}</td>
						<td className="text-sm">{v.action}</td>
						<td>{buttons}</td>
					</tr>
				)
			}
		})

		return (
			<div className="mt-5">
				<h3>ARC Documents History for {this.state.data.lot?.address}</h3>
				<table className="dataTable tight">
					<thead>
						<tr className="font-bold">
							<th className="w-[150px]">Snapshot Date</th>
							<th className="w-[200px]">Action</th>
							<th>Files</th>
						</tr>
					</thead>
					<tbody>{ret}</tbody>
				</table>
			</div>
		)
	}

	historyLots = () => {
		if (!settings?.arc) return
		const data = []

		_.forEach(this.props.payload.historyLots, (v) => {
			let section = _.find(this.props.payload.public.sections, { id: v.section_id })
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let final, viewResponseFile, viewPlans, start, complete, planFile, history
			let sale_status = v.lot_status
			if (!sale_status) sale_status = "Available Lot"
			let construction_status
			if (v.complete_date) construction_status = "Completed"
			else if (v.start_date) construction_status = "Under Construction"
			else construction_status = "Vacant"

			if (!settings?.disabled?.finalReview) {
				if (settings.arc) {
					if (v?.arc_data?.fr === true && v?.arc_data?.fr_plan_file) {
						final = (
							<a className="btn" target="_blank" href={`${settings.s3}${v.arc_data.fr_plan_file}`}>
								View Final Review
							</a>
						)
					} else if (
						(v?.arc_data?.fr === null || v?.arc_data?.fr === false) &&
						v.complete_date &&
						v?.arc_data?.fr_review_date
					) {
						// rejected is false, awaiting is null
						final = (
							<button
								className={classNames("btn", {
									"btn--attention": v?.arc_data?.fr === false,
								})}
								onClick={() => this.buttonClick("finalModal", v)}>
								Resubmit Final Review
							</button>
						)
					} else if (v?.arc_data?.fr === undefined && v.complete_date) {
						// no fr
						final = (
							<button className="btn" onClick={() => this.buttonClick("finalModal", v)}>
								Submit Final Review
							</button>
						)
					}
				}
				if (v.arc_data) {
					let files = {
						approved: _.get(v.arc_data, `approval_file`),
						rejected: _.get(v.arc_data, `rejection_file`),
						conditional: _.get(v.arc_data, `conditional_file`),
					}
					if (v.arc_approved && files.approved && _.get(v.arc_data, `current_status`) == "approved") {
						viewResponseFile = (
							<a
								className="btn"
								target="_blank"
								onClick={() => {
									this.generateResponseFile(v)
								}}>
								Approved Response File
							</a>
						)
					} else if (files.conditional && _.get(v.arc_data, `current_status`) == "conditional") {
						viewResponseFile = (
							<a
								className="btn"
								target="_blank"
								onClick={() => {
									this.generateResponseFile(v)
								}}>
								Conditional Response File
							</a>
						)
					} else if (files.rejected && _.get(v.arc_data, `current_status`) == "rejected") {
						viewResponseFile = (
							<a className="btn" target="_blank" href={`${settings.s3}${files.rejected}`}>
								Rejected Response File
							</a>
						)
					}
				}
			}
			if (v.arc_approved && _.has(v.arc_data, `approval_date`)) {
				// This is split out because thsi means pipsy was in control when this was approved.  If it's not, like during import of a new developer, then we probably won't have this info.
				viewPlans = (
					<button className="btn darkGreen" onClick={() => this.buttonClick("viewApproved", v)}>
						View Approved Plans
					</button>
				)
			}

			if (!v.start_date && !settings?.disableBuilderConstructionStatus) {
				start = (
					<button
						className={classnames("btn", { "btn--attention": v.missing_start })}
						onClick={() => this.buttonClick("startModal", v)}>
						Add Start
					</button>
				)
			}

			if (v.start_date && !v.complete_date && !settings?.disableBuilderConstructionStatus) {
				complete = (
					<button
						className={classnames("btn", { "btn--attention": v.missing_complete })}
						onClick={() => this.buttonClick("completeModal", v)}>
						Add Complete
					</button>
				)
			}

			if (v?.arc_data?.plan_file) {
				planFile = (
					<a className="btn" target="_blank" href={`${settings.s3}${v.arc_data.plan_file}`}>
						View Plan File
					</a>
				)
			}
			if (v.arc_history) {
				history = (
					<button className="btn" onClick={() => this.setState({ historyModal: true, data: { lot: v } })}>
						View History
					</button>
				)
			}

			let actions = (
				<div>
					{final}
					{viewResponseFile}
					{viewPlans}
					{start}
					{complete}
					{planFile}
					{history}
				</div>
			)

			data.push({
				..._.pick(v, ["address", "lot", "block", "closing_date"]),
				community: property ? property.name : "",
				section: section ? section.name : "",
				sale_status,
				construction_status,
				actions,
			})
		})
		return (
			<div className="content">
				<h2>Lot History</h2>
				<ReactTable
					filterable
					loadingText=""
					data={data}
					columns={[
						{
							Header: "Community",
							accessor: "community",
							filterMethod: (f, r) => helpers.tableText(f, r, "community"),
						},
						{
							Header: "Address",
							accessor: "address",
							filterMethod: (f, r) => helpers.tableText(f, r, "address"),
						},
						{
							Header: "Lot",
							accessor: "lot",
							filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
						},
						{
							Header: "Block",
							accessor: "block",
							filterMethod: (f, r) => helpers.tableText(f, r, "block"),
						},
						{
							Header: "Section",
							accessor: "section",
							filterMethod: (f, r) => helpers.tableText(f, r, "section"),
						},
						{
							Header: "Sale Status",
							accessor: "sale_status",
							filterMethod: (f, r) => helpers.tableText(f, r, "sale_status"),
						},
						{
							Header: "Construction Status",
							accessor: "construction_status",
							filterMethod: (f, r) => helpers.tableText(f, r, "construction_status"),
						},
						{
							Header: "Closing Date",
							accessor: "closing_date",
							filterMethod: (f, r) => helpers.tableText(f, r, "closing_date"),
							Cell: (v) => helpers.tableDate(v),
						},
						{
							Header: "Actions",
							accessor: "actions",
							filterMethod: (f, r) => helpers.tableText(f, r, "actions"),
						},
					]}
					defaultPageSize={10}
					className="small"
				/>
			</div>
		)
	}

	getTrProps = (state, rowInfo, instance) => {
		if (rowInfo && !settings.disablePaperwork) {
			let v = rowInfo.original
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let className = ""
			if (v.documents && v.documents.length > 0) {
				let rejects = _.find(v.documents, { status: "rejected" })
				let awaiting = _.find(v.documents, { status: "awaiting" })
				let pending = _.find(v.documents, { status: "pending" })
				let allApproved = false
				if (!pending && !awaiting && !rejects) {
					allApproved = true
					_.forEach(v.documents, (r) => {
						if (r.status !== "accepted") {
							allApproved = false
						}
					})
				}
				// Order matters here
				// Pending is above awaiting simply due to the fact that some people submit combined documents
				if (rejects) {
					className = "statusColor--rejected"
				} else if (pending) {
					className = "statusColor--pending"
				} else if (awaiting && property && property.no_paperwork !== 1) {
					className = "statusColor--awaiting"
				} else if (allApproved) {
					className = "statusColor--approved"
				}
			} else if (!v.documents && v.sale_date && property && !property.no_paperwork) {
				className = "statusColor--awaiting"
			}
			return {
				className: className,
			}
		}
		return {}
	}

	generateResponseFile = async (lot) => {
		this.props.loadingStatus(true)
		let resp = await submitDataAsync("mainIngest", {
			lot_id: lot.id,
			action: "buildLotResponseFile",
		})
		let url = settings.s3 + "/" + resp.message
		if (resp.status == 200) {
			toast.success("Response file generated")
			window.open(url, "_blank")
		} else {
			toast.error("Error generating response file")
		}
		this.props.loadingStatus(false)
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		}
		return (
			<div className="lotInventory">
				<div className="imageGroup">
					<Title title="Lot Inventory" showDate={false} />
					<div className="content">{this.renderInventory()}</div>
					{this.historyLots()}
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.bustoutModal}
						onClose={() => this.setState({ bustoutModal: false })}
						center>
						<BustoutModal data={this.state.data} notify={this.notify} name="bustoutModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.transferModal}
						onClose={() => this.setState({ transferModal: false })}
						center>
						<TransferModal data={this.state.data} notify={this.notify} name="transferModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.closingModal}
						onClose={() => this.setState({ closingModal: false })}
						center>
						<ClosingModal data={this.state.data} notify={this.notify} name="closingModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.contractModal}
						onClose={() => this.setState({ contractModal: false })}
						center>
						<ContractModal data={this.state.data} notify={this.notify} name="contractModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.startModal}
						onClose={() => this.setState({ startModal: false })}
						center>
						<StartModal data={this.state.data} notify={this.notify} name="startModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.completeModal}
						onClose={() => this.setState({ completeModal: false })}
						center>
						<CompleteModal data={this.state.data} notify={this.notify} name="completeModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.estimatedModal}
						onClose={() => this.setState({ estimatedModal: false })}
						center>
						<EstimatedModal data={this.state.data} notify={this.notify} name="estimatedModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.moveInDateModal}
						onClose={() => this.setState({ moveInDateModal: false })}
						center>
						<MoveInDate data={this.state.data} notify={this.notify} name="moveInDateModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.buyerModal}
						onClose={() => this.setState({ buyerModal: false })}
						center>
						<BuyerModal data={this.state.data} notify={this.notify} name="buyerModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm full" }}
						open={this.state.arcModal}
						onClose={() => this.setState({ arcModal: false })}
						center>
						<ArcModal
							data={this.state.data}
							payload={this.props.payload}
							notify={this.notify}
							name="arcModal"
						/>
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.finalModal}
						onClose={() => this.setState({ finalModal: false })}
						center>
						<FinalModal data={this.state.data} notify={this.notify} name="finalModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.viewApproved}
						onClose={() => this.setState({ viewApproved: false })}
						center>
						<ArcViewApprovedLot data={this.state.data} notify={this.notify} name="viewApproved" />
					</Modal>
					<Modal
						classNames={{ modal: "modal" }}
						open={this.state.openHouseModal}
						onClose={() => this.setState({ openHouseModal: false })}
						center>
						<OpenHouse data={this.state.data} notify={this.notify} name="openHouse" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.lotReservationModal}
						onClose={() => this.setState({ lotReservationModal: false })}
						center>
						<LotReservationModal data={this.state.data} notify={this.notify} name="lotReservation" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.websiteInfoModal}
						onClose={() => this.setState({ websiteInfoModal: false })}
						center>
						<WebsiteInfoBuilders data={this.state.data} notify={this.notify} name="websiteInfoBuilders" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.editHomeInfoModal}
						onClose={() => this.setState({ editHomeInfoModal: false })}
						center>
						<EditHomeInfo data={this.state.data} notify={this.notify} name="editHomeInfoModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.feesModal}
						onClose={() => this.setState({ feesModal: false })}
						center>
						<Fees data={this.state.data} notify={this.notify} name="feesModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.historyModal}
						onClose={() => this.setState({ historyModal: false })}
						center>
						{this.documentsList()}
					</Modal>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		trafficSources: state.trafficSources,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(withRouter(LotInventory))
